<template>
  <div>
    <div class="article-by-id p-3">
      <PageTitle :main="article.name" :lastUpdate="article.lastUpdate" :userUpdate="article.userUpdate"
        :sub="article.description" />
      <div class="text-breadcrumb" v-if="path">
        <div>{{ path }}</div>
      </div>
      <div ref="#buttonTop" @click="returnToTop" class="button-top" :style="styleButtonTop" title="Voltar ao topo">
        <mdicon size="40" name="chevron-up" />
      </div>
      <div style="height: 400px; flex-direction: column" v-if="progress"
        class="d-flex align-items-center justify-content-center">
        <p>Carregando artigo...</p>
        <b-spinner variant="dark" label="Loading..."></b-spinner>
      </div>
      <div class="d-flex">
        <!-- <div
        style="width: 25%; background: linear-gradient(to right, #adb5bd, #fff)"
        class="d-none d-xl-block"
      ></div> -->
        <div style="width: 100%">
          <div v-if="!progress" style="width: 100%" class="d-flex justify-content-start">
            <p @click="back" class="back">
              <mdicon size="20" name="arrow-left-bold" />
              <strong> Voltar</strong>
            </p>
          </div>

          <div style="overflow: auto; position: relative">
            <div class="article-content" v-html="article.content"></div>
          </div>

          <div v-show="!progress && showEvaluationInformation" class="flex-column p-4">
            <div class="d-flex">
              <span>
                <h1 class="title">
                  <strong>Avaliações</strong>
                </h1>
              </span>
              <span>
                <p style="font-size: 0.9rem" class="ml-2 mb-0">
                  ({{ totalRatings }})
                </p>
              </span>
            </div>
            <div class="d-flex align-items-center">
              <span v-if="generalEvaluation">({{ generalEvaluation | formatNumber }})</span>
              <b-form-rating class="shadow-none border-0 p-0 m-0" variant="warning" v-model="generalEvaluation" inline
                readonly></b-form-rating>

              <b-button v-if="!wasEvaluated" @click="showModal = true" class="ml-4" size="sm">Avaliar artigo</b-button>
              <p v-else class="m-0 ml-4">Você já avaliou.</p>
            </div>
          </div>

          <div v-show="!progress">
            <Comments :idArticle="article.id" :comments="article.comments" />
          </div>

          <div v-if="!progress" style="width: 100%" class="d-flex justify-content-start">
            <p @click="back" class="back">
              <mdicon size="20" name="arrow-left-bold" /><strong>
                Voltar</strong>
            </p>
          </div>
        </div>
      </div>
      <b-modal v-model="showModal" title="Avaliação" style="background-color: green" header-bg-variant="dark"
        header-text-variant="light" centered body-bg-variant="light">
        <!-- <template #modal-header>
        <div class="header-modal">
          <p>Avaliação</p>
        </div>
      </template> -->
        <b-container fluid>
          <div class="d-flex align-items-center justify-content-center p-0 m-0">
            <Rating v-if="!wasEvaluated" :grade="grade" :maxStars="5" :hasCounter="true" @grade="grade = $event" />
            <p class="m-0" v-else>Obrigado pela sua avaliação :)</p>
          </div>
        </b-container>
        <template #modal-footer>
          <button @click="cancelRating" size="sm" class="button-cancel float-right mt-0 mb-0">
            Cancelar
          </button>
          <b-button @click="saveRating" variant="dark" size="sm" class="float-right mt-0 mb-0 mr-0"
            :disabled="grade === 0">
            Enviar
          </b-button>
        </template>
      </b-modal>
    </div>
    <Footer v-show="article.id !== undefined" />
  </div>
</template>

<script>
import "highlightjs/styles/dracula.css";
import hljs from "highlightjs/highlight.pack.js";
import { baseApiUrl } from "@/global";
import axios from "axios";
import PageTitle from "../template/PageTitle";
import Rating from "../Rating.vue";
import { mapState } from "vuex";
import Footer from "../template/Footer.vue";
import Comments from "../comment/Comments.vue";

export default {
  name: "ArticleById",
  components: { Rating, PageTitle, Footer, Comments },
  data: function () {
    return {
      grade: 0,
      article: {
        comments: [],
      },
      progress: true,
      categoryId: 0,
      path: '',
      generalEvaluation: 0.0,
      totalRatings: 0,
      wasEvaluated: false,
      windowTop: 0,
      showModal: false,
      showEvaluationInformation: false,
      styleButtonTop: "visibility: hidden;opacity: 0;",
      ip: "",
    };
  },
  watch: {
    // eslint-disable-next-line
    $route(to) {
      this.$store.commit("toggleFooter", false);
      this.article = {};
      this.showEvaluationInformation = false;
      this.progress = true;
      this.loadArticle();
    },
    windowTop(value) {
      if (value >= 300) {
        this.styleButtonTop = `
        visibility: visible;
        opacity: 1; `;
      } else {
        this.styleButtonTop = `
        transition-property: opacity, visibility;
        transition-delay: 0s, 0.3s;
        visibility: hidden;
        opacity: 0; 
        `;
      }
    },
    // ip: {
    //   handler(value) {
    //     if (value !== "") {
    //       this.saveRating();
    //     }
    //   },
    // },
  },
  computed: {
    ...mapState(["user"]),
    contentStyle() {
      if (this.$mq === "lg" || this.$mq === "xl") {
        return "container-article";
      } else {
        return "";
      }
    },
  },
  methods: {
    loadArticle() {
      const routeParams = this.$route.params.name.split("-");
      const id = routeParams[routeParams.length - 1];
      const url = `${baseApiUrl}/api/publico/artigos/${id}`;
      return axios.get(url).then((res) => {
        this.categoryId = res.data.categoryId;
        this.article = res.data;
        this.progress = false;
        this.$store.commit("toggleFooter", true);
        this.checkEvaluatedArticle();
        this.viewedArticle(id);
        this.getCategory();
      });
    },
    viewedArticle(idArticle) {
      const url = `${baseApiUrl}/api/publico/artigos/${idArticle}/visualizacao`;
      axios.put(url).then();
    },
    cancelRating() {
      this.grade = 0;
      this.showModal = false;
    },
    getCategory() {
      const idCategory = this.categoryId;
      const url = `${baseApiUrl}/api/publico/categorias/${idCategory}`;
      axios.get(url).then((result) => {
        this.path = result.data.path;
      });
    },
    checkEvaluatedArticle() {
      axios.get("https://ipapi.co/json/").then((res) => {
        this.ip = res.data.ip;
        const url = `${baseApiUrl}/api/publico/artigos/${this.article.id}/avaliacoes?ipUsuario=${this.ip}`;
        axios.get(url).then((res) => {
          this.wasEvaluated = res.data.wasEvaluated;
          this.generalEvaluation = res.data.generalEvaluation;
          this.totalRatings = res.data.totalRatings;
          this.showEvaluationInformation = true;
        });
      });
    },
    // shootIp() {
    //   axios.get("https://www.cloudflare.com/cdn-cgi/trace").then((res) => {
    //     const arrayData = res.data.split("\n");
    //     console.log(arrayData);
    //   });
    //   axios.get("https://ipapi.co/json/").then((res) => {
    //     this.ip = res.data.ip;
    //   });
    // },
    saveRating() {
      const url = `${baseApiUrl}/api/publico/artigos/${this.article.id}/avaliacoes?ipUsuario=${this.ip}&estrelas=${this.grade}`;
      axios.post(url).then(() => {
        this.grade = 0;
        this.checkEvaluatedArticle();
        setTimeout(() => {
          this.showModal = false;
        }, 2000);
      });
      // alert(
      //   `user: ${this.ip}, idArticle: ${this.article.id}, rating: ${this.grade}`
      // );

      // this.ip = "";
    },
    back() {
      return this.$router.go(-1);
    },
    onScroll() {
      this.windowTop = window.top.scrollY;
    },
    returnToTop() {
      const timer = setInterval(() => {
        this.windowTop = this.windowTop - 2 * 20;
        window.scrollTo(0, this.windowTop);
        if (this.windowTop < 0) {
          window.scrollTo(0, 0);
          clearInterval(timer);
          // done();
        }
      }, 5);
    },
  },
  mounted() {
    this.$store.commit("toggleFooter", false);
    window.addEventListener("scroll", this.onScroll);
    // this.$store.commit("toggleMenu", false);
    // this.$store.commit("toggleIconMenu", false);
    this.loadArticle();
  },
  updated() {
    document.querySelectorAll(".article-content pre").forEach((e) => {
      hljs.highlightBlock(e);
    });
  },
};
</script>

<style>
.article-content {
  color: #545454;
  width: 100%;
  /* border-radius: 8px; */
  padding: 5px 20px;
  word-wrap: break-word;
}

.button-top {
  cursor: pointer;
  border-radius: 50%;
  position: fixed;
  z-index: 6;
  background-color: #ececec;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  color: #545454;
  right: 5%;
  bottom: 50px;

  transition-duration: 0.3s, 0s;
  transition-timing-function: ease, ease;
  transition: opacity 0.3s 0s, visibility 0s 0s;
  transition-delay: 0s, 0s;
}

.button-top:hover {
  /* border-radius: 50%;
  position: fixed;
  z-index: 6;
  background-color: #ececec; */
  color: #545454;
  /* right: 50px;
  bottom: 450px; */
}

.back {
  display: flex;
  align-items: center;
  color: #545454;
  font-size: 1.2rem;
  margin-top: 0px;
  margin-bottom: 15px;
  margin-left: 10px;
  cursor: pointer;
}

.title {
  margin: 0;
  color: #545454;
  font-size: 1.2rem;
}

.button-cancel {
  border: solid 2px #545454;
  border-radius: 4px;
  color: #545454;
  background-color: #fff;
}

/* .button-cancel:hover {

} */

/* .header-modal {
  position: absolute;
  top: 0;
  left: 0;
  height: 32px;
  width: 100%;
  background-color: #414345;
  display: flex;
  align-items: center;
}

.header-modal p {
  margin: 0 0 0 10px;
  color: #fff;
  font-size: 1.2rem;
} */

.article-content pre {
  padding: 20px;
  /* border-radius: 8px; */
  font-size: 1.2rem;
  background-color: #1e1e1e;
  color: #fff;
}

@media only screen and (max-width: 576px) and (max-width: 826px) {
  :root {
    --width-iframe: 300px;
  }
}

@media only screen and (min-width: 827px) and (max-width: 960px) {
  :root {
    --width-iframe: 600px;
  }
}

@media only screen and (min-width: 961px) and (max-width: 1024px) {
  :root {
    --width-iframe: 600px;
  }
}

@media only screen and (min-width: 1025px) {
  :root {
    --width-iframe: 800px;
  }
}

.article-content iframe {
  width: var(--width-iframe);
  height: calc((var(--width-iframe)) / 2);
}

.article-content ul {
  margin: 0;
}

.article-content table {
  display: table;
  width: 800px;
  text-align: start;
}

.article-content table .td-align-center {
  background-color: #fff;
  text-align: start;
}

.article-content table tr {
  display: table-row;
  border-collapse: collapse;
}

.article-content table tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03);
}

.article-content table tr:hover {
  background-color: #ececec;
}

.article-content p {
  margin: 0;
}

.article-content table td {
  border: solid 2px #ececec;
}

.article-content img {
  max-width: 100%;
}

.article-content :last-child {
  margin-bottom: 0px;
}

.text-breadcrumb {
  font-size: 0.8rem;
  color: #777;
  margin-top: 5px;
  margin-left: 16px;
}
</style>